/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';
import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';
import type {
  AnalysisResponse,
  ConvertResultDetailResponse,
  ConvertResultExpenditureOptionsResponse,
  ExpenditurePredictionAccuracyResponse,
  PagedConvertResultsResponse,
  PagedExpenditureRecordsResponse,
  PagedRevenueAxisRevenueAppropriationsResponse,
  PagedRevenueRecordsResponse,
  RevenuePredictionAccuracyResponse,
  SettlementStatisticsConvertResponse,
  SettlementStatisticsExpenditureNatureListResponse,
  SettlementStatisticsExpenditurePurposeListResponse,
  SettlementStatisticsRevenueAppropriationResponse,
  SettlementStatisticsRevenuePurposeListResponse,
  SuccessResponse,
} from './model';
import { ConvertResultsStatus } from './model';

export const getGetConvertResultsResponseMock = (): PagedConvertResultsResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        title: faker.string.alpha({ length: { min: 1, max: 255 } }),
        fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
        status: faker.helpers.arrayElement(Object.values(ConvertResultsStatus)),
        convert_started_at: faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          null,
        ]),
        convert_completed_at: faker.helpers.arrayElement([
          faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, null]),
          undefined,
        ]),
        converted_by_id: faker.string.uuid(),
        has_expenditure_inference: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
        has_revenue_inference: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
        has_revenue_appropriation_inference: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
        has_label_for_expenditure_target_data: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
        has_label_for_revenue_target_data: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
      }),
    ),
  },
});

export const getGetConvertResultResponseMock = (
  overrideResponse: Partial<ConvertResultDetailResponse> = {},
): ConvertResultDetailResponse => ({
  id: faker.string.uuid(),
  title: faker.string.alpha({ length: { min: 1, max: 255 } }),
  fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
  expenditure_base_fiscal_year: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: 1900, max: 2100 }), null]),
    undefined,
  ]),
  revenue_base_fiscal_year: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: 1900, max: 2100 }), null]),
    undefined,
  ]),
  revenue_appropriation_base_fiscal_year: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: 1900, max: 2100 }), null]),
    undefined,
  ]),
  status: faker.helpers.arrayElement(Object.values(ConvertResultsStatus)),
  convert_started_at: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    null,
  ]),
  convert_completed_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, null]),
    undefined,
  ]),
  converted_by_id: faker.string.uuid(),
  has_expenditure_inference: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  has_revenue_inference: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  has_revenue_appropriation_inference: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  has_label_for_expenditure_target_data: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  has_label_for_revenue_target_data: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  target_ordinary_balance_ratio: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
      null,
    ]),
    undefined,
  ]),
  base_ordinary_balance_ratio: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
      null,
    ]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDeleteConvertResultResponseMock = (): SuccessResponse => ({ success: true });

export const getSettlementStatisticsConvertResponseMock = (
  overrideResponse: Partial<SettlementStatisticsConvertResponse> = {},
): SettlementStatisticsConvertResponse => ({ id: faker.string.uuid(), ...overrideResponse });

export const getGetConvertResultExpenditureOptionsResponseMock =
  (): ConvertResultExpenditureOptionsResponse => ({
    accounting_types: [{ code: '01', name: '一般会計' }],
    expenditure_purposes: [
      {
        parent_accounting_type_code: '01',
        kan_code: '01',
        kan_name: '議会費',
        ko_code: '01',
        ko_name: '議会費',
        moku_code: '01',
        moku_name: '議会費',
      },
    ],
    expenditure_natures: [
      {
        setsu_code: '01',
        setsu_name: '報酬',
        saisetsu_code: '01',
        saisetsu_name: '報酬細節',
        saisaisetsu_code: '01',
        saisaisetsu_name: '報酬細々節',
      },
    ],
    expenditure_settlement_purposes: [
      {
        id: 'd2d43ca5-0000-0000-0000-000000000001',
        level1_code: '01',
        level1_name: '議会費',
        level2_code: '',
        level2_name: '',
        level3_code: '',
        level3_name: '',
        level4_code: '',
        level4_name: '',
      },
    ],
    revenue_natures: [
      {
        parent_accounting_type_code: '01',
        kan_code: '01',
        kan_name: '地方税',
        ko_code: '01',
        ko_name: '市町村民税',
        moku_code: '01',
        moku_name: '個人',
        setsu_code: '01',
        setsu_name: '均等割',
        saisetsu_code: '01',
        saisetsu_name: '現年課税分',
        saisaisetsu_code: '',
        saisaisetsu_name: '',
      },
    ],
  });

export const getGetConvertResultSettlementStatisticsExpenditurePurposesResponseMock =
  (): SettlementStatisticsExpenditurePurposeListResponse =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      id: faker.string.uuid(),
      convert_result_id: faker.string.uuid(),
      level1_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level1_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level2_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level2_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level3_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level3_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level4_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level4_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
    }));

export const getPostSettlementStatisticsExpenditurePurposeResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getPatchSettlementStatisticsExpenditurePurposeResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getDeleteSettlementStatisticsExpenditurePurposeResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getGetConvertResultSettlementStatisticsExpenditureNaturesResponseMock =
  (): SettlementStatisticsExpenditureNatureListResponse =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      id: faker.string.uuid(),
      convert_result_id: faker.string.uuid(),
      level1_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level1_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level2_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level2_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level3_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level3_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level4_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level4_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
    }));

export const getPostSettlementStatisticsExpenditureNatureResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getPatchSettlementStatisticsExpenditureNatureResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getDeleteSettlementStatisticsExpenditureNatureResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getGetConvertResultSettlementStatisticsRevenuePurposesResponseMock =
  (): SettlementStatisticsRevenuePurposeListResponse =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      id: faker.string.uuid(),
      convert_result_id: faker.string.uuid(),
      level1_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level1_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level2_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level2_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level3_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level3_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level4_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
      level4_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
    }));

export const getPostSettlementStatisticsRevenuePurposeResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getPatchSettlementStatisticsRevenuePurposeResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getDeleteSettlementStatisticsRevenuePurposeResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getGetConvertResultExpendituresResponseMock = (): PagedExpenditureRecordsResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
        organization_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        organization_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        accounting_type_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        accounting_type_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        kan_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        kan_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        ko_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        ko_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        moku_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        moku_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        project_category1_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        project_category1_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        project_category2_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        project_category2_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        project_category3_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        project_category3_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        project_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        project_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        setsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        setsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        saisetsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        saisetsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        saisaisetsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        saisaisetsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        description: faker.string.alpha({ length: { min: 10, max: 20 } }),
        amount: faker.number.int({ min: undefined, max: undefined }),
        settlement_purpose_value: faker.helpers.arrayElement([
          {
            id: faker.string.uuid(),
            level1_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level1_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level2_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level2_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level3_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level3_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level4_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level4_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          },
          undefined,
        ]),
        settlement_nature_value: faker.helpers.arrayElement([
          {
            id: faker.string.uuid(),
            level1_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level1_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level2_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level2_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level3_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level3_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level4_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level4_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          },
          undefined,
        ]),
        recurring_type_value: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
          undefined,
        ]),
        funding_type_value: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
          undefined,
        ]),
        settlement_purpose_prediction_confidence: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
            null,
          ]),
          undefined,
        ]),
        settlement_nature_prediction_confidence: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
            null,
          ]),
          undefined,
        ]),
        recurring_type_prediction_confidence: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
            null,
          ]),
          undefined,
        ]),
        funding_type_prediction_confidence: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
            null,
          ]),
          undefined,
        ]),
      }),
    ),
  },
});

export const getGetConvertResultRevenuesResponseMock = (): PagedRevenueRecordsResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
        organization_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        organization_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        accounting_type_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        accounting_type_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        kan_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        kan_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        ko_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        ko_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        moku_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        moku_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        setsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        setsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        saisetsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        saisetsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        saisaisetsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        saisaisetsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        description: faker.string.alpha({ length: { min: 10, max: 20 } }),
        amount: faker.number.int({ min: undefined, max: undefined }),
        settlement_purpose_value: faker.helpers.arrayElement([
          {
            id: faker.string.uuid(),
            level1_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level1_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level2_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level2_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level3_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level3_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level4_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            level4_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          },
          undefined,
        ]),
        recurring_type_value: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
          undefined,
        ]),
        revenue_source_type_value: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
          undefined,
        ]),
        settlement_purpose_prediction_confidence: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
            null,
          ]),
          undefined,
        ]),
        recurring_type_prediction_confidence: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
            null,
          ]),
          undefined,
        ]),
        revenue_source_type_prediction_confidence: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
            null,
          ]),
          undefined,
        ]),
      }),
    ),
  },
});

export const getPatchSettlementStatisticsRevenueResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getGetConvertResultRevenueAxisRevenueAppropriationsResponseMock =
  (): PagedRevenueAxisRevenueAppropriationsResponse => ({
    ...{ count: faker.number.int({ min: undefined, max: undefined }) },
    ...{
      items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          revenue_record_id: faker.string.uuid(),
          accounting_type_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          accounting_type_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          organization_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          organization_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_kan_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_kan_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_ko_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_ko_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_moku_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_moku_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_setsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_setsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_saisetsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_saisetsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_saisaisetsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_saisaisetsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          settlement_purpose1_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          settlement_purpose1_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          settlement_purpose2_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          settlement_purpose2_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          settlement_purpose3_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          settlement_purpose3_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          settlement_purpose4_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          settlement_purpose4_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          recurring_type: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_source_type: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_total_amount: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          past_year_revenue_total_amount: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          revenue_appropriation_amount: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          past_year_revenue_appropriation_amount: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          expenditure_summary_records: Array.from(
            { length: faker.number.int({ min: 1, max: 10 }) },
            (_, i) => i + 1,
          ).map(() => ({
            expenditure_summary_id: faker.string.uuid(),
            revenue_appropriation_id: faker.string.uuid(),
            fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
            accounting_type_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            accounting_type_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            expenditure_kan_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            expenditure_kan_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            expenditure_ko_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            expenditure_ko_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            expenditure_moku_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            expenditure_moku_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            project_category1_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            project_category1_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            project_category2_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            project_category2_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            project_category3_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            project_category3_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            project_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            project_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_purpose1_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_purpose1_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_purpose2_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_purpose2_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_purpose3_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_purpose3_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_purpose4_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_purpose4_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_nature1_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_nature1_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_nature2_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_nature2_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_nature3_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_nature3_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_nature4_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
            settlement_nature4_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
            recurring_type: faker.string.alpha({ length: { min: 10, max: 20 } }),
            funding_type: faker.string.alpha({ length: { min: 10, max: 20 } }),
            expenditure_amount: faker.helpers.arrayElement([
              faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                null,
              ]),
              undefined,
            ]),
            past_year_expenditure_amount: faker.helpers.arrayElement([
              faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                null,
              ]),
              undefined,
            ]),
            total_appropriation_amount: faker.helpers.arrayElement([
              faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                null,
              ]),
              undefined,
            ]),
            past_year_total_appropriation_amount: faker.helpers.arrayElement([
              faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                null,
              ]),
              undefined,
            ]),
          })),
        }),
      ),
    },
  });

export const getGetConvertResultExpenditureAnalysisResponseMock = (
  overrideResponse: Partial<AnalysisResponse> = {},
): AnalysisResponse => ({
  rows: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    code: faker.string.alpha({ length: { min: 10, max: 20 } }),
    name: faker.string.alpha({ length: { min: 10, max: 20 } }),
    can_drill_down: faker.datatype.boolean(),
  })),
  column_groups: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () =>
      Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
        code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        can_drill_down: faker.datatype.boolean(),
      })),
  ),
  cells: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      base_amount: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
        undefined,
      ]),
      target_amount: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
        undefined,
      ]),
      drill_through_params: faker.helpers.arrayElement([
        {
          row_axis_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          column_axis1_code: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.string.alpha({ length: { min: 10, max: 20 } }),
              null,
            ]),
            undefined,
          ]),
          column_axis2_code: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.string.alpha({ length: { min: 10, max: 20 } }),
              null,
            ]),
            undefined,
          ]),
          column_axis3_code: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.string.alpha({ length: { min: 10, max: 20 } }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
    })),
  ),
  ...overrideResponse,
});

export const getGetConvertResultRevenueAnalysisResponseMock = (
  overrideResponse: Partial<AnalysisResponse> = {},
): AnalysisResponse => ({
  rows: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    code: faker.string.alpha({ length: { min: 10, max: 20 } }),
    name: faker.string.alpha({ length: { min: 10, max: 20 } }),
    can_drill_down: faker.datatype.boolean(),
  })),
  column_groups: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () =>
      Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
        code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        can_drill_down: faker.datatype.boolean(),
      })),
  ),
  cells: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      base_amount: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
        undefined,
      ]),
      target_amount: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
        undefined,
      ]),
      drill_through_params: faker.helpers.arrayElement([
        {
          row_axis_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          column_axis1_code: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.string.alpha({ length: { min: 10, max: 20 } }),
              null,
            ]),
            undefined,
          ]),
          column_axis2_code: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.string.alpha({ length: { min: 10, max: 20 } }),
              null,
            ]),
            undefined,
          ]),
          column_axis3_code: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.string.alpha({ length: { min: 10, max: 20 } }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
    })),
  ),
  ...overrideResponse,
});

export const getGetConvertResultRevenueAppropriationAnalysisResponseMock = (
  overrideResponse: Partial<AnalysisResponse> = {},
): AnalysisResponse => ({
  rows: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    code: faker.string.alpha({ length: { min: 10, max: 20 } }),
    name: faker.string.alpha({ length: { min: 10, max: 20 } }),
    can_drill_down: faker.datatype.boolean(),
  })),
  column_groups: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () =>
      Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
        code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        can_drill_down: faker.datatype.boolean(),
      })),
  ),
  cells: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() =>
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      base_amount: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
        undefined,
      ]),
      target_amount: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
        undefined,
      ]),
      drill_through_params: faker.helpers.arrayElement([
        {
          row_axis_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          column_axis1_code: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.string.alpha({ length: { min: 10, max: 20 } }),
              null,
            ]),
            undefined,
          ]),
          column_axis2_code: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.string.alpha({ length: { min: 10, max: 20 } }),
              null,
            ]),
            undefined,
          ]),
          column_axis3_code: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.string.alpha({ length: { min: 10, max: 20 } }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
    })),
  ),
  ...overrideResponse,
});

export const getPatchSettlementStatisticsExpenditureResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getGetConvertResultExpenditurePredictionAccuracyResponseMock = (
  overrideResponse: Partial<ExpenditurePredictionAccuracyResponse> = {},
): ExpenditurePredictionAccuracyResponse => ({
  expenditure_purpose_accuracy: faker.helpers.arrayElement([
    faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    null,
  ]),
  expenditure_nature_accuracy: faker.helpers.arrayElement([
    faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    null,
  ]),
  recurring_type_accuracy: faker.helpers.arrayElement([
    faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    null,
  ]),
  funding_type_accuracy: faker.helpers.arrayElement([
    faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    null,
  ]),
  details: {
    expenditure_purposes: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      title: faker.string.alpha({ length: { min: 10, max: 20 } }),
      precision: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      recall: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      f1_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      confusion_matrix: faker.helpers.arrayElement([
        {
          tp: faker.number.int({ min: undefined, max: undefined }),
          tn: faker.number.int({ min: undefined, max: undefined }),
          fp: faker.number.int({ min: undefined, max: undefined }),
          fn: faker.number.int({ min: undefined, max: undefined }),
        },
        undefined,
      ]),
    })),
    expenditure_natures: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      title: faker.string.alpha({ length: { min: 10, max: 20 } }),
      precision: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      recall: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      f1_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      confusion_matrix: faker.helpers.arrayElement([
        {
          tp: faker.number.int({ min: undefined, max: undefined }),
          tn: faker.number.int({ min: undefined, max: undefined }),
          fp: faker.number.int({ min: undefined, max: undefined }),
          fn: faker.number.int({ min: undefined, max: undefined }),
        },
        undefined,
      ]),
    })),
    recurring_types: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      title: faker.string.alpha({ length: { min: 10, max: 20 } }),
      precision: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      recall: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      f1_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      confusion_matrix: faker.helpers.arrayElement([
        {
          tp: faker.number.int({ min: undefined, max: undefined }),
          tn: faker.number.int({ min: undefined, max: undefined }),
          fp: faker.number.int({ min: undefined, max: undefined }),
          fn: faker.number.int({ min: undefined, max: undefined }),
        },
        undefined,
      ]),
    })),
    funding_types: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      title: faker.string.alpha({ length: { min: 10, max: 20 } }),
      precision: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      recall: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      f1_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      confusion_matrix: faker.helpers.arrayElement([
        {
          tp: faker.number.int({ min: undefined, max: undefined }),
          tn: faker.number.int({ min: undefined, max: undefined }),
          fp: faker.number.int({ min: undefined, max: undefined }),
          fn: faker.number.int({ min: undefined, max: undefined }),
        },
        undefined,
      ]),
    })),
  },
  ...overrideResponse,
});

export const getGetConvertResultRevenuePredictionAccuracyResponseMock = (
  overrideResponse: Partial<RevenuePredictionAccuracyResponse> = {},
): RevenuePredictionAccuracyResponse => ({
  revenue_purpose_accuracy: faker.helpers.arrayElement([
    faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    null,
  ]),
  recurring_type_accuracy: faker.helpers.arrayElement([
    faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    null,
  ]),
  revenue_source_type_accuracy: faker.helpers.arrayElement([
    faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    null,
  ]),
  details: {
    revenue_purposes: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      title: faker.string.alpha({ length: { min: 10, max: 20 } }),
      precision: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      recall: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      f1_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      confusion_matrix: faker.helpers.arrayElement([
        {
          tp: faker.number.int({ min: undefined, max: undefined }),
          tn: faker.number.int({ min: undefined, max: undefined }),
          fp: faker.number.int({ min: undefined, max: undefined }),
          fn: faker.number.int({ min: undefined, max: undefined }),
        },
        undefined,
      ]),
    })),
    recurring_types: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      title: faker.string.alpha({ length: { min: 10, max: 20 } }),
      precision: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      recall: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      f1_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      confusion_matrix: faker.helpers.arrayElement([
        {
          tp: faker.number.int({ min: undefined, max: undefined }),
          tn: faker.number.int({ min: undefined, max: undefined }),
          fp: faker.number.int({ min: undefined, max: undefined }),
          fn: faker.number.int({ min: undefined, max: undefined }),
        },
        undefined,
      ]),
    })),
    revenue_source_types: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      title: faker.string.alpha({ length: { min: 10, max: 20 } }),
      precision: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      recall: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      f1_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
          null,
        ]),
        undefined,
      ]),
      confusion_matrix: faker.helpers.arrayElement([
        {
          tp: faker.number.int({ min: undefined, max: undefined }),
          tn: faker.number.int({ min: undefined, max: undefined }),
          fp: faker.number.int({ min: undefined, max: undefined }),
          fn: faker.number.int({ min: undefined, max: undefined }),
        },
        undefined,
      ]),
    })),
  },
  ...overrideResponse,
});

export const getPostSettlementStatisticsRevenueAppropriationResponseMock = (
  overrideResponse: Partial<SettlementStatisticsRevenueAppropriationResponse> = {},
): SettlementStatisticsRevenueAppropriationResponse => ({
  revenue_appropriation_id: faker.string.uuid(),
  expenditure_summary_id: faker.string.uuid(),
  revenue_id: faker.string.uuid(),
  revenue_appropriation_amount: faker.number.int({ min: undefined, max: undefined }),
  ...overrideResponse,
});

export const getPatchSettlementStatisticsRevenueAppropriationResponseMock =
  (): SuccessResponse => ({ success: true });

export const getDeleteSettlementStatisticsRevenueAppropriationResponseMock =
  (): SuccessResponse => ({ success: true });

export const getGetConvertResultsMockHandler = (
  overrideResponse?:
    | PagedConvertResultsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PagedConvertResultsResponse> | PagedConvertResultsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultMockHandler = (
  overrideResponse?:
    | ConvertResultDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ConvertResultDetailResponse> | ConvertResultDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteConvertResultMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/settlement-statistics/convert-results/:convertResultId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteConvertResultResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getSettlementStatisticsConvertMockHandler = (
  overrideResponse?:
    | SettlementStatisticsConvertResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SettlementStatisticsConvertResponse> | SettlementStatisticsConvertResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/settlement-statistics/convert',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getSettlementStatisticsConvertResponseMock(),
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultExpenditureOptionsMockHandler = (
  overrideResponse?:
    | ConvertResultExpenditureOptionsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<ConvertResultExpenditureOptionsResponse>
        | ConvertResultExpenditureOptionsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/options',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultExpenditureOptionsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultSettlementStatisticsExpenditurePurposesMockHandler = (
  overrideResponse?:
    | SettlementStatisticsExpenditurePurposeListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<SettlementStatisticsExpenditurePurposeListResponse>
        | SettlementStatisticsExpenditurePurposeListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-expenditure-purposes',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultSettlementStatisticsExpenditurePurposesResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPostSettlementStatisticsExpenditurePurposeMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-expenditure-purposes',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPostSettlementStatisticsExpenditurePurposeResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPatchSettlementStatisticsExpenditurePurposeMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-expenditure-purposes/:settlementStatisticsExpenditurePurposeId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPatchSettlementStatisticsExpenditurePurposeResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteSettlementStatisticsExpenditurePurposeMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-expenditure-purposes/:settlementStatisticsExpenditurePurposeId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteSettlementStatisticsExpenditurePurposeResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultSettlementStatisticsExpenditureNaturesMockHandler = (
  overrideResponse?:
    | SettlementStatisticsExpenditureNatureListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<SettlementStatisticsExpenditureNatureListResponse>
        | SettlementStatisticsExpenditureNatureListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-expenditure-natures',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultSettlementStatisticsExpenditureNaturesResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPostSettlementStatisticsExpenditureNatureMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-expenditure-natures',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPostSettlementStatisticsExpenditureNatureResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPatchSettlementStatisticsExpenditureNatureMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-expenditure-natures/:settlementStatisticsExpenditureNatureId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPatchSettlementStatisticsExpenditureNatureResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteSettlementStatisticsExpenditureNatureMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-expenditure-natures/:settlementStatisticsExpenditureNatureId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteSettlementStatisticsExpenditureNatureResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultSettlementStatisticsRevenuePurposesMockHandler = (
  overrideResponse?:
    | SettlementStatisticsRevenuePurposeListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<SettlementStatisticsRevenuePurposeListResponse>
        | SettlementStatisticsRevenuePurposeListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-revenue-purposes',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultSettlementStatisticsRevenuePurposesResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPostSettlementStatisticsRevenuePurposeMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-revenue-purposes',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPostSettlementStatisticsRevenuePurposeResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPatchSettlementStatisticsRevenuePurposeMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-revenue-purposes/:settlementStatisticsRevenuePurposeId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPatchSettlementStatisticsRevenuePurposeResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteSettlementStatisticsRevenuePurposeMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/settlement-statistics/convert-results/:convertResultId/settlement-statistics-revenue-purposes/:settlementStatisticsRevenuePurposeId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteSettlementStatisticsRevenuePurposeResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultExpendituresMockHandler = (
  overrideResponse?:
    | PagedExpenditureRecordsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PagedExpenditureRecordsResponse> | PagedExpenditureRecordsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/expenditures',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultExpendituresResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultRevenuesMockHandler = (
  overrideResponse?:
    | PagedRevenueRecordsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PagedRevenueRecordsResponse> | PagedRevenueRecordsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/revenues',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultRevenuesResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPatchSettlementStatisticsRevenueMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/settlement-statistics/convert-results/:convertResultId/revenues/:revenueId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPatchSettlementStatisticsRevenueResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultRevenueAxisRevenueAppropriationsMockHandler = (
  overrideResponse?:
    | PagedRevenueAxisRevenueAppropriationsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<PagedRevenueAxisRevenueAppropriationsResponse>
        | PagedRevenueAxisRevenueAppropriationsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/revenue-axis-revenue-appropriations',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultRevenueAxisRevenueAppropriationsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultExpenditureAnalysisMockHandler = (
  overrideResponse?:
    | AnalysisResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AnalysisResponse> | AnalysisResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/expenditure-analysis',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultExpenditureAnalysisResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultRevenueAnalysisMockHandler = (
  overrideResponse?:
    | AnalysisResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AnalysisResponse> | AnalysisResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/revenue-analysis',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultRevenueAnalysisResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultRevenueAppropriationAnalysisMockHandler = (
  overrideResponse?:
    | AnalysisResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AnalysisResponse> | AnalysisResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/revenue-appropriation-analysis',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultRevenueAppropriationAnalysisResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPatchSettlementStatisticsExpenditureMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/settlement-statistics/convert-results/:convertResultId/expenditures/:expenditureId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPatchSettlementStatisticsExpenditureResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultExpenditurePredictionAccuracyMockHandler = (
  overrideResponse?:
    | ExpenditurePredictionAccuracyResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ExpenditurePredictionAccuracyResponse> | ExpenditurePredictionAccuracyResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/expenditure-prediction-accuracy',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultExpenditurePredictionAccuracyResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetConvertResultRevenuePredictionAccuracyMockHandler = (
  overrideResponse?:
    | RevenuePredictionAccuracyResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<RevenuePredictionAccuracyResponse> | RevenuePredictionAccuracyResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/settlement-statistics/convert-results/:convertResultId/revenue-prediction-accuracy',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetConvertResultRevenuePredictionAccuracyResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPostSettlementStatisticsRevenueAppropriationMockHandler = (
  overrideResponse?:
    | SettlementStatisticsRevenueAppropriationResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<SettlementStatisticsRevenueAppropriationResponse>
        | SettlementStatisticsRevenueAppropriationResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/settlement-statistics/convert-results/:convertResultId/revenue-appropriations',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPostSettlementStatisticsRevenueAppropriationResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPatchSettlementStatisticsRevenueAppropriationMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/settlement-statistics/convert-results/:convertResultId/revenue-appropriations/:revenueAppropriationId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPatchSettlementStatisticsRevenueAppropriationResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteSettlementStatisticsRevenueAppropriationMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/settlement-statistics/convert-results/:convertResultId/revenue-appropriations/:revenueAppropriationId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteSettlementStatisticsRevenueAppropriationResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [
  getGetConvertResultsMockHandler(),
  getGetConvertResultMockHandler(),
  getDeleteConvertResultMockHandler(),
  getSettlementStatisticsConvertMockHandler(),
  getGetConvertResultExpenditureOptionsMockHandler(),
  getGetConvertResultSettlementStatisticsExpenditurePurposesMockHandler(),
  getPostSettlementStatisticsExpenditurePurposeMockHandler(),
  getPatchSettlementStatisticsExpenditurePurposeMockHandler(),
  getDeleteSettlementStatisticsExpenditurePurposeMockHandler(),
  getGetConvertResultSettlementStatisticsExpenditureNaturesMockHandler(),
  getPostSettlementStatisticsExpenditureNatureMockHandler(),
  getPatchSettlementStatisticsExpenditureNatureMockHandler(),
  getDeleteSettlementStatisticsExpenditureNatureMockHandler(),
  getGetConvertResultSettlementStatisticsRevenuePurposesMockHandler(),
  getPostSettlementStatisticsRevenuePurposeMockHandler(),
  getPatchSettlementStatisticsRevenuePurposeMockHandler(),
  getDeleteSettlementStatisticsRevenuePurposeMockHandler(),
  getGetConvertResultExpendituresMockHandler(),
  getGetConvertResultRevenuesMockHandler(),
  getPatchSettlementStatisticsRevenueMockHandler(),
  getGetConvertResultRevenueAxisRevenueAppropriationsMockHandler(),
  getGetConvertResultExpenditureAnalysisMockHandler(),
  getGetConvertResultRevenueAnalysisMockHandler(),
  getGetConvertResultRevenueAppropriationAnalysisMockHandler(),
  getPatchSettlementStatisticsExpenditureMockHandler(),
  getGetConvertResultExpenditurePredictionAccuracyMockHandler(),
  getGetConvertResultRevenuePredictionAccuracyMockHandler(),
  getPostSettlementStatisticsRevenueAppropriationMockHandler(),
  getPatchSettlementStatisticsRevenueAppropriationMockHandler(),
  getDeleteSettlementStatisticsRevenueAppropriationMockHandler(),
];
